// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Dialog layout ────────────────────────────────────────────── */
mat-dialog-content {
  min-width: 480px;
  min-height: 380px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.button-gap { gap: 12px; }

/* ── Table layout ─────────────────────────────────────────────── */
.subscription-table {
  border-collapse: collapse;
  width: 100%;
}

.subscription-table tbody tr {
  border-bottom: 1px solid #f0f0f0;
}

.subscription-table tbody tr:last-child {
  border-bottom: none;
}

.subscription-table tbody tr:hover {
  background-color: #f8f9fa;
}

.row-readonly {
  background-color: #fafafa;
}

/* ── Cells ────────────────────────────────────────────────────── */
.cb-cell {
  width: 36px;
  padding: 10px 8px 10px 4px;
  vertical-align: middle;
}

.label-cell {
  padding: 10px 8px;
  vertical-align: middle;
  font-size: 0.9rem;
  color: #333;
}

.badge-cell {
  width: 60px;
  padding: 10px 4px;
  vertical-align: middle;
  text-align: right;
}

/* ── Custom checkbox — forces correct rendering despite NextPage CSS ── */
.cb-wrap {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  margin: 0;
  padding: 0;
  position: relative;
  width: 18px;
  height: 18px;
}

/* Hide native input completely */
.sub-checkbox {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
}

/* Custom visual box */
.cb-box {
  display: inline-block;
  width: 17px;
  height: 17px;
  border: 2px solid #aaa;
  border-radius: 3px;
  background: #fff;
  box-sizing: border-box;
  flex-shrink: 0;
  transition: border-color 0.15s, background 0.15s;
}

/* Checked state */
.sub-checkbox:checked + .cb-box {
  background-color: #0b2d71;
  border-color: #0b2d71;
}

/* Checkmark */
.sub-checkbox:checked + .cb-box::after {
  content: '';
  display: block;
  width: 5px;
  height: 9px;
  border: 2px solid #fff;
  border-top: none;
  border-left: none;
  transform: rotate(45deg);
  margin: 1px auto 0;
}

/* Disabled state */
.sub-checkbox:disabled + .cb-box {
  background-color: #e9ecef;
  border-color: #ccc;
  cursor: not-allowed;
}

.sub-checkbox:disabled:checked + .cb-box {
  background-color: #6c8cbf;
  border-color: #6c8cbf;
}

.cb-wrap:has(.sub-checkbox:disabled) {
  cursor: not-allowed;
}

/* ── Group badge ──────────────────────────────────────────────── */
.group-badge {
  font-size: 0.70rem;
  color: #777;
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 2px 5px;
  white-space: nowrap;
}

/* ── Suppress NextPage.min.css arrow on buttons ────────────────────────── */
.btn::after { content: '' !important; display: none !important; }

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/tools/email-subscriptions/email-subscriptions.component.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,cAAc,SAAS,EAAE;;AAEzB,oEAAoE;AACpE;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oEAAoE;AACpE;EACE,WAAW;EACX,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,0EAA0E;AAC1E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,gDAAgD;AAClD;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,6EAA6E;AAC7E,cAAc,sBAAsB,EAAE,wBAAwB,EAAE","sourcesContent":["/* ── Dialog layout ────────────────────────────────────────────── */\nmat-dialog-content {\n  min-width: 480px;\n  min-height: 380px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.button-gap { gap: 12px; }\n\n/* ── Table layout ─────────────────────────────────────────────── */\n.subscription-table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.subscription-table tbody tr {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.subscription-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.subscription-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.row-readonly {\n  background-color: #fafafa;\n}\n\n/* ── Cells ────────────────────────────────────────────────────── */\n.cb-cell {\n  width: 36px;\n  padding: 10px 8px 10px 4px;\n  vertical-align: middle;\n}\n\n.label-cell {\n  padding: 10px 8px;\n  vertical-align: middle;\n  font-size: 0.9rem;\n  color: #333;\n}\n\n.badge-cell {\n  width: 60px;\n  padding: 10px 4px;\n  vertical-align: middle;\n  text-align: right;\n}\n\n/* ── Custom checkbox — forces correct rendering despite NextPage CSS ── */\n.cb-wrap {\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  width: 18px;\n  height: 18px;\n}\n\n/* Hide native input completely */\n.sub-checkbox {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n  margin: 0;\n  padding: 0;\n}\n\n/* Custom visual box */\n.cb-box {\n  display: inline-block;\n  width: 17px;\n  height: 17px;\n  border: 2px solid #aaa;\n  border-radius: 3px;\n  background: #fff;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n/* Checked state */\n.sub-checkbox:checked + .cb-box {\n  background-color: #0b2d71;\n  border-color: #0b2d71;\n}\n\n/* Checkmark */\n.sub-checkbox:checked + .cb-box::after {\n  content: '';\n  display: block;\n  width: 5px;\n  height: 9px;\n  border: 2px solid #fff;\n  border-top: none;\n  border-left: none;\n  transform: rotate(45deg);\n  margin: 1px auto 0;\n}\n\n/* Disabled state */\n.sub-checkbox:disabled + .cb-box {\n  background-color: #e9ecef;\n  border-color: #ccc;\n  cursor: not-allowed;\n}\n\n.sub-checkbox:disabled:checked + .cb-box {\n  background-color: #6c8cbf;\n  border-color: #6c8cbf;\n}\n\n.cb-wrap:has(.sub-checkbox:disabled) {\n  cursor: not-allowed;\n}\n\n/* ── Group badge ──────────────────────────────────────────────── */\n.group-badge {\n  font-size: 0.70rem;\n  color: #777;\n  background-color: #f0f0f0;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 2px 5px;\n  white-space: nowrap;\n}\n\n/* ── Suppress NextPage.min.css arrow on buttons ────────────────────────── */\n.btn::after { content: '' !important; display: none !important; }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
